const watermark = {}

const hexToRgb = (hex, a) => {
	let rgba = 'rgba('
	hex = hex.replace('#', '')
	for (let i = 0; i < hex.length; i += 2) {
		rgba += parseInt(hex.slice(i, i + 2), 16) + ','
	}
	rgba += a + ')'
	return rgba
}

// text 水印名称
// sourceBody 水印容器
// coroptical 水印透明度
// incline 水印倾斜度
// lrMargin 左右间距
// topbomMargin 上下间距
// fontSize 字体大小
// fontFamily 字体
// waterHeight 水印高度
// fontColor 水印颜色

function initWatermark(ctx) {
  ctx.$https.get('index/watermark').then(res => {
    console.log("水印---", res);

    let text = res.data.watermark;
    let sourceBody = '';
    let coroptical = res.data.coroptical;
    let incline = res.data.incline;
    let lrMargin = res.data.lrMargin;
    let topbomMargin = res.data.topbomMargin;
    let fontSize = res.data.fontSize;
    let fontFamily = res.data.fontFamily;
    let waterHeight = res.data.waterHeight;
    let fontColor = res.data.fontColor;

    if (text !== 'no') {
      watermark.set(text, sourceBody, coroptical, incline, lrMargin, topbomMargin, fontSize, fontFamily, waterHeight, fontColor);
    }
  });
}

const setWatermark = (text, sourceBody, coroptical = 0.2, incline = -0.3, lrMargin = 200, topbomMargin = 150, fontSize =
	'15px', fontFamily = 'Vedana', waterHeight = 150, fontColor = '#bebebe') => {
	const id =
		Math.random() * 10000 +
		'-' +
		Math.random() * 10000 +
		'/' +
		Math.random() * 10000

	if (document.getElementById(id) !== null) {
		document.body.removeChild(document.getElementById(id))
	}

	const can = document.createElement('canvas')

	can.width = lrMargin // 设置水印之间的左右间距

	can.height = topbomMargin // 设置水印之间的上下间距

	const cans = can.getContext('2d')

	cans.rotate(incline)

	cans.font = fontSize + ' ' + fontFamily

	const fontColorStle = hexToRgb(fontColor, coroptical)

	cans.fillStyle = fontColorStle

	cans.textAlign = 'left'
	cans.textBaseline = 'Middle'

	cans.fillText(text, can.width / 20, waterHeight)

	const wateDiv = document.createElement('div')
	wateDiv.id = id
	wateDiv.className = 'watermarkClass'
	wateDiv.style.pointerEvents = 'none'
	wateDiv.style.background =
		'url(' + can.toDataURL('image/png') + ') left top repeat'

	wateDiv.style.top = '3px'
	wateDiv.style.left = '0px'
	wateDiv.style.position = 'fixed'

	wateDiv.style.zIndex = '100000'
	wateDiv.style.width = document.documentElement.clientWidth + 'px'
	wateDiv.style.height = document.documentElement.clientHeight + 'px'

	if (sourceBody) {
		sourceBody.appendChild(wateDiv)
	} else {
		document.body.appendChild(wateDiv)
	}

	return id
}

/**
 *  该方法只允许调用一次
 *  @param:
 *  @text == 水印内容
 *  @sourceBody == 水印添加的位置，不传就是body
 * */
watermark.set = (text, sourceBody, coroptical, incline, lrMargin, topbomMargin, fontSize, fontFamily, waterHeight,
	fontColor) => {
	const domArr = Array.from(document.getElementsByClassName('watermarkClass'))
	for (let i = 0; i < domArr.length; i++) {
		const element = domArr[i]
		element.remove()
	}
	if (text === '') {
		return
	}

	setWatermark(text, sourceBody, coroptical, incline, lrMargin, topbomMargin, fontSize, fontFamily, waterHeight,
		fontColor)
}

export default {watermark,initWatermark}


// WEBPACK FOOTER //
// ./src/mixins/Watermark.js